module.exports = __webpack_public_path__ + "img/new-s-cross-2023.83e406e4.536cb035.svg";